import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PageWithSidebar from 'components/PageWithSidebar';
import CitySidebar from 'components/CitySidebar';
import CityEditForm from 'components/CityEditForm';

import { withData } from 'lib';

import { SettingsCityEditPageQuery } from '__generated__/SettingsCityEditPageQuery.graphql';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import NotFound from 'components/NotFound';

const query = graphql`
  query SettingsCityEditPageQuery($id: ID!) {
    city(id: $id) {
      name

      region {
        id
        name

        country {
          id
          name
        }
      }

      ...CityEditForm_city
      ...CitySidebar_city
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCityEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/countries', name: 'Vietos' },
];

const SettingsCityEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { city } = usePreloadedQuery<SettingsCityEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!city) {
    return <NotFound />;
  }

  const { name, region } = city;
  const { country } = region;

  return (
    <PageWithSidebar
      sidebar={<CitySidebar city={city} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          link: `/settings/countries/${country.id}#regions`,
          name: country.name,
        },
        {
          link: `/settings/regions/${region.id}#cities`,
          name: region.name,
        },
        { name },
      ]}>
      <CityEditForm city={city} />
    </PageWithSidebar>
  );
};

export default withData<SettingsCityEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsCityEditPage);
